import { AxiosError } from 'axios';
import qs from 'qs';
import ApiClient from 'services/axios-config';
import { AdminAssessment } from 'types/AdminAssessment';

import SearchAssessmentsRequest, { SearchAssessmentsQueryParams } from './types/Assessment/SearchAssessmentsRequest';
import SearchLeadersRequest from './types/Assessment/SearchLeadersRequest';
import SearchFoldersRequest, { SearchFoldersQueryParams } from './types/Folder/SearchFoldersRequest';
import GenerateBatchReports from './types/Report/GenerateBatchReports';

const lpiApi = '/lpi/api/v4';

export const AdminService = {
  Assessment: {
    SearchAssessments: async (
      queryParams: SearchAssessmentsQueryParams,
      request: SearchAssessmentsRequest,
    ): Promise<AdminAssessment[]> => {
      const { organizationId } = queryParams;
      try {
        const { data } = await ApiClient.client.post(`api/v4/lpi-assessments/search?organizationId=${organizationId}`, {
          ...request,
          paramsSerializer: (params: any) => {
            return qs.stringify(params, { arrayFormat: 'comma' });
          },
        });

        return data.items;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        throw axiosError;
      }
    },
  },
  Leader: {
    SearchLeaders: async (request: SearchLeadersRequest): Promise<Leader[]> => {
      try {
        if (request.keyword) {
          request.keyword = request.keyword.replace(/\s+/g, ','); // Replace spaces with commas
        }

        const { data } = await ApiClient.client.get(`${lpiApi}/lpi-leaders/search`, { params: request });

        return data.items;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        throw axiosError;
      }
    },
  },
  Report: {
    GenerateBatchReports: async (request: GenerateBatchReports): Promise<{ url: string }> => {
      try {
        const { data } = await ApiClient.client.post('/api/v4/batch-reports', {
          ...request,
          path: `/reports/${request.path}`,
          settings: {
            selector: 'section',
            styles: {
              width: 6.5,
              height: 8.5,
              scale: 1,
            },
          },
        },
        {
          baseURL: window.env.PUBLIC_BATCH_REPORTS_API_BASE_URL,
        });

        return data;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        throw axiosError;
      }
    },
  },
  Folder: {
    SearchFolders: async (queryParams: SearchFoldersQueryParams, request: SearchFoldersRequest): Promise<Folder[]> => {
      try {
        const { offset, size, include } = queryParams;
        const  query = `offset=${offset || 0}${size ? `&size=${size || 10}` : ''}&include=${include || 'none'}`;

        const { data } = await ApiClient.client.post(`/api/v4/folders/search?${query}`, {
          request,
          paramsSerializer: (params: any) => {
            return qs.stringify(params, { arrayFormat: 'comma' });
          },
        });

        return data.items;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        throw axiosError;
      }
    },
  },
  Company: {
    GetOrganizationUserRoles: async (userId: number): Promise<OrganizationUserRole[]> => {
      const queryParams = `organizationRole=OrgAdmin&userId=${userId}`;

      try {
        const { data } = await ApiClient.client.get(`api/v4/organization-user-roles?${queryParams}`,
          {
            baseURL: window.env.PUBLIC_COMPANY_API_BASE_URL,
          },
        );

        return data.items;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        throw axiosError;
      }
    },
  },
};
